import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

import { addClasses, createCSSRule, removeClasses, asCSSUrl } from '../../../base/browser/dom.js';
import { domEvent } from '../../../base/browser/event.js';
import { Separator } from '../../../base/common/actions.js';
import { Emitter } from '../../../base/common/event.js';
import { IdGenerator } from '../../../base/common/idGenerator.js';
import { toDisposable, MutableDisposable, DisposableStore } from '../../../base/common/lifecycle.js';
import { isLinux, isWindows } from '../../../base/common/platform.js';
import { localize } from '../../../nls.js';
import { MenuItemAction } from '../common/actions.js';
import { IContextMenuService } from '../../contextview/browser/contextView.js';
import { IKeybindingService } from '../../keybinding/common/keybinding.js';
import { INotificationService } from '../../notification/common/notification.js';
import { ThemeIcon } from '../../theme/common/themeService.js';
import { ActionViewItem } from '../../../base/browser/ui/actionbar/actionViewItems.js';
import { DropdownMenuActionViewItem } from '../../../base/browser/ui/dropdown/dropdownActionViewItem.js'; // The alternative key on all platforms is alt. On windows we also support shift as an alternative key #44136

var AlternativeKeyEmitter = /*#__PURE__*/function (_Emitter) {
  _inherits(AlternativeKeyEmitter, _Emitter);

  var _super = _createSuper(AlternativeKeyEmitter);

  function AlternativeKeyEmitter(contextMenuService) {
    var _this;

    _classCallCheck(this, AlternativeKeyEmitter);

    _this = _super.call(this);
    _this._subscriptions = new DisposableStore();
    _this._isPressed = false;
    _this._suppressAltKeyUp = false;

    _this._subscriptions.add(domEvent(document.body, 'keydown')(function (e) {
      _this.isPressed = e.altKey || (isWindows || isLinux) && e.shiftKey;
    }));

    _this._subscriptions.add(domEvent(document.body, 'keyup')(function (e) {
      if (_this.isPressed) {
        if (_this._suppressAltKeyUp) {
          e.preventDefault();
        }
      }

      _this._suppressAltKeyUp = false;
      _this.isPressed = false;
    }));

    _this._subscriptions.add(domEvent(document.body, 'mouseleave')(function (e) {
      return _this.isPressed = false;
    }));

    _this._subscriptions.add(domEvent(document.body, 'blur')(function (e) {
      return _this.isPressed = false;
    })); // Workaround since we do not get any events while a context menu is shown


    _this._subscriptions.add(contextMenuService.onDidContextMenu(function () {
      return _this.isPressed = false;
    }));

    return _this;
  }

  _createClass(AlternativeKeyEmitter, [{
    key: "isPressed",
    get: function get() {
      return this._isPressed;
    },
    set: function set(value) {
      this._isPressed = value;
      this.fire(this._isPressed);
    }
  }, {
    key: "suppressAltKeyUp",
    value: function suppressAltKeyUp() {
      // Sometimes the native alt behavior needs to be suppresed since the alt was already used as an alternative key
      // Example: windows behavior to toggle tha top level menu #44396
      this._suppressAltKeyUp = true;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(AlternativeKeyEmitter.prototype), "dispose", this).call(this);

      this._subscriptions.dispose();
    }
  }], [{
    key: "getInstance",
    value: function getInstance(contextMenuService) {
      if (!AlternativeKeyEmitter.instance) {
        AlternativeKeyEmitter.instance = new AlternativeKeyEmitter(contextMenuService);
      }

      return AlternativeKeyEmitter.instance;
    }
  }]);

  return AlternativeKeyEmitter;
}(Emitter);

export function createAndFillInActionBarActions(menu, options, target, isPrimaryGroup) {
  var groups = menu.getActions(options); // Action bars handle alternative actions on their own so the alternative actions should be ignored

  fillInActions(groups, target, false, isPrimaryGroup);
  return asDisposable(groups);
}

function asDisposable(groups) {
  var disposables = new DisposableStore();

  var _iterator = _createForOfIteratorHelper(groups),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
          actions = _step$value[1];

      var _iterator2 = _createForOfIteratorHelper(actions),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var action = _step2.value;
          disposables.add(action);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return disposables;
}

function fillInActions(groups, target, useAlternativeActions) {
  var isPrimaryGroup = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (group) {
    return group === 'navigation';
  };

  var _iterator3 = _createForOfIteratorHelper(groups),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var tuple = _step3.value;

      var _tuple = _slicedToArray(tuple, 2),
          group = _tuple[0],
          actions = _tuple[1];

      if (useAlternativeActions) {
        actions = actions.map(function (a) {
          return a instanceof MenuItemAction && !!a.alt ? a.alt : a;
        });
      }

      if (isPrimaryGroup(group)) {
        var to = Array.isArray(target) ? target : target.primary;
        to.unshift.apply(to, _toConsumableArray(actions));
      } else {
        var _to = Array.isArray(target) ? target : target.secondary;

        if (_to.length > 0) {
          _to.push(new Separator());
        }

        _to.push.apply(_to, _toConsumableArray(actions));
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
}

var ids = new IdGenerator('menu-item-action-item-icon-');
var ICON_PATH_TO_CSS_RULES = new Map();

var MenuEntryActionViewItem = /*#__PURE__*/function (_ActionViewItem) {
  _inherits(MenuEntryActionViewItem, _ActionViewItem);

  var _super2 = _createSuper(MenuEntryActionViewItem);

  function MenuEntryActionViewItem(_action, _keybindingService, _notificationService, _contextMenuService) {
    var _this2;

    _classCallCheck(this, MenuEntryActionViewItem);

    _this2 = _super2.call(this, undefined, _action, {
      icon: !!(_action.class || _action.item.icon),
      label: !_action.class && !_action.item.icon
    });
    _this2._action = _action;
    _this2._keybindingService = _keybindingService;
    _this2._notificationService = _notificationService;
    _this2._wantsAltCommand = false;
    _this2._itemClassDispose = _this2._register(new MutableDisposable());
    _this2._altKey = AlternativeKeyEmitter.getInstance(_contextMenuService);
    return _this2;
  }

  _createClass(MenuEntryActionViewItem, [{
    key: "_commandAction",
    get: function get() {
      return this._wantsAltCommand && this._action.alt || this._action;
    }
  }, {
    key: "onClick",
    value: function onClick(event) {
      var _this3 = this;

      event.preventDefault();
      event.stopPropagation();

      if (this._altKey.isPressed) {
        this._altKey.suppressAltKeyUp();
      }

      this.actionRunner.run(this._commandAction, this._context).then(undefined, function (err) {
        return _this3._notificationService.error(err);
      });
    }
  }, {
    key: "render",
    value: function render(container) {
      var _this4 = this;

      _get(_getPrototypeOf(MenuEntryActionViewItem.prototype), "render", this).call(this, container);

      this._updateItemClass(this._action.item);

      var mouseOver = false;
      var alternativeKeyDown = this._altKey.isPressed;

      var updateAltState = function updateAltState() {
        var wantsAltCommand = mouseOver && alternativeKeyDown;

        if (wantsAltCommand !== _this4._wantsAltCommand) {
          _this4._wantsAltCommand = wantsAltCommand;

          _this4.updateLabel();

          _this4.updateTooltip();

          _this4.updateClass();
        }
      };

      if (this._action.alt) {
        this._register(this._altKey.event(function (value) {
          alternativeKeyDown = value;
          updateAltState();
        }));
      }

      this._register(domEvent(container, 'mouseleave')(function (_) {
        mouseOver = false;
        updateAltState();
      }));

      this._register(domEvent(container, 'mouseenter')(function (e) {
        mouseOver = true;
        updateAltState();
      }));
    }
  }, {
    key: "updateLabel",
    value: function updateLabel() {
      if (this.options.label && this.label) {
        this.label.textContent = this._commandAction.label;
      }
    }
  }, {
    key: "updateTooltip",
    value: function updateTooltip() {
      if (this.label) {
        var keybinding = this._keybindingService.lookupKeybinding(this._commandAction.id);

        var keybindingLabel = keybinding && keybinding.getLabel();
        var tooltip = this._commandAction.tooltip || this._commandAction.label;
        this.label.title = keybindingLabel ? localize('titleAndKb', "{0} ({1})", tooltip, keybindingLabel) : tooltip;
      }
    }
  }, {
    key: "updateClass",
    value: function updateClass() {
      if (this.options.icon) {
        if (this._commandAction !== this._action) {
          if (this._action.alt) {
            this._updateItemClass(this._action.alt.item);
          }
        } else if (this._action.alt) {
          this._updateItemClass(this._action.item);
        }
      }
    }
  }, {
    key: "_updateItemClass",
    value: function _updateItemClass(item) {
      var _this5 = this;

      var _a, _b;

      this._itemClassDispose.value = undefined;
      var icon = this._commandAction.checked && ((_a = item.toggled) === null || _a === void 0 ? void 0 : _a.icon) ? item.toggled.icon : item.icon;

      if (ThemeIcon.isThemeIcon(icon)) {
        // theme icons
        var iconClass = ThemeIcon.asClassName(icon);

        if (this.label && iconClass) {
          addClasses(this.label, iconClass);
          this._itemClassDispose.value = toDisposable(function () {
            if (_this5.label) {
              removeClasses(_this5.label, iconClass);
            }
          });
        }
      } else if (icon) {
        // icon path
        var _iconClass;

        if ((_b = icon.dark) === null || _b === void 0 ? void 0 : _b.scheme) {
          var iconPathMapKey = icon.dark.toString();

          if (ICON_PATH_TO_CSS_RULES.has(iconPathMapKey)) {
            _iconClass = ICON_PATH_TO_CSS_RULES.get(iconPathMapKey);
          } else {
            _iconClass = ids.nextId();
            createCSSRule(".icon.".concat(_iconClass), "background-image: ".concat(asCSSUrl(icon.light || icon.dark)));
            createCSSRule(".vs-dark .icon.".concat(_iconClass, ", .hc-black .icon.").concat(_iconClass), "background-image: ".concat(asCSSUrl(icon.dark)));
            ICON_PATH_TO_CSS_RULES.set(iconPathMapKey, _iconClass);
          }

          if (this.label) {
            addClasses(this.label, 'icon', _iconClass);
            this._itemClassDispose.value = toDisposable(function () {
              if (_this5.label) {
                removeClasses(_this5.label, 'icon', _iconClass);
              }
            });
          }
        }
      }
    }
  }]);

  return MenuEntryActionViewItem;
}(ActionViewItem);

MenuEntryActionViewItem = __decorate([__param(1, IKeybindingService), __param(2, INotificationService), __param(3, IContextMenuService)], MenuEntryActionViewItem);
export { MenuEntryActionViewItem };

var SubmenuEntryActionViewItem = /*#__PURE__*/function (_DropdownMenuActionVi) {
  _inherits(SubmenuEntryActionViewItem, _DropdownMenuActionVi);

  var _super3 = _createSuper(SubmenuEntryActionViewItem);

  function SubmenuEntryActionViewItem(action, _notificationService, _contextMenuService) {
    _classCallCheck(this, SubmenuEntryActionViewItem);

    var _a;

    var classNames = [];

    if (action.item.icon) {
      if (ThemeIcon.isThemeIcon(action.item.icon)) {
        classNames.push(ThemeIcon.asClassName(action.item.icon));
      } else if ((_a = action.item.icon.dark) === null || _a === void 0 ? void 0 : _a.scheme) {
        var iconPathMapKey = action.item.icon.dark.toString();

        if (ICON_PATH_TO_CSS_RULES.has(iconPathMapKey)) {
          classNames.push('icon', ICON_PATH_TO_CSS_RULES.get(iconPathMapKey));
        } else {
          var className = ids.nextId();
          classNames.push('icon', className);
          createCSSRule(".icon.".concat(className), "background-image: ".concat(asCSSUrl(action.item.icon.light || action.item.icon.dark)));
          createCSSRule(".vs-dark .icon.".concat(className, ", .hc-black .icon.").concat(className), "background-image: ".concat(asCSSUrl(action.item.icon.dark)));
          ICON_PATH_TO_CSS_RULES.set(iconPathMapKey, className);
        }
      }
    }

    return _super3.call(this, action, action.actions, _contextMenuService, {
      classNames: classNames
    });
  }

  return SubmenuEntryActionViewItem;
}(DropdownMenuActionViewItem);

SubmenuEntryActionViewItem = __decorate([__param(1, INotificationService), __param(2, IContextMenuService)], SubmenuEntryActionViewItem);
export { SubmenuEntryActionViewItem };